// src/app/components/donate-banner/donate-banner.component.ts
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-donate-banner',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './donate-banner.component.html',
  styleUrls: ['./donate-banner.component.css'],
})
export class DonateBannerComponent {
  visible = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.visible = !sessionStorage.getItem('donateBannerDismissed');
    }
  }

  dismiss(): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('donateBannerDismissed', 'true');
    }
    this.visible = false;
  }
}
